module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-75.dc23d177.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-75.png
// module id = 3281
// module chunks = 11